export default __webpack_public_path__ + "static/SRUS SB121 - Especification Del Producto y Datos Técnicos-8ee9bf9e364cf4482580bb5424ae6409.pdf";